import SnippetIcon from '@/components/atom/icon/search/SnippetIcon';

interface Props {
  keyword: string;
  navigateToDoctorList: () => void;
}

const NonFaceToFacePrescriptionSnippet = ({ keyword, navigateToDoctorList }: Props) => {
  return (
    <div className='border-0 border-b-[16px] border-b-gray-30 border-solid p-[28px_20px]'>
      <div className={'px-[4px]'}>
        <div className={'mb-[24px] flex flex-col gap-[8px]'}>
          <SnippetIcon />
          <span className={'typography-ui-24b whitespace-pre text-gray-900'}>
            <span className={'text-primary-700'}>{keyword}</span> 처방,{'\n'}비대면으로 가능해요!
          </span>
          <span className={'typography-ui-15r text-gray-400'}>언제 어디서든 편하게 진료 받을 수 있어요.</span>
        </div>
        <button
          className={'typography-ui-17sb h-[48px] w-full rounded-[12px] bg-primary-600 text-white'}
          onClick={navigateToDoctorList}
        >
          비대면 진료 받으러 가기
        </button>
      </div>
    </div>
  );
};

export default NonFaceToFacePrescriptionSnippet;
